import EventAgent from '@hotmart-org-ca/event-agent-js'
import type HubMetrify from '@hotmart-org-ca/event-agent-js/dist/models/hub-metrify'

import { System, DATA_VERSION, EVENT_VERSION } from './'

import type { FeatureMetrify, InjectionErrorEvent } from './'

EventAgent.mode = location.hostname.endsWith('buildstaging.com') ? 'staging' : 'production'

class DatahubEvent {
  static sendEvent(datahubObject: Partial<HubMetrify>) {
    EventAgent.sendMetrify(datahubObject)
  }

  static send(eventDataHub: FeatureMetrify) {
    const event: Partial<HubMetrify> = {
      system: System.MEMBERSHIP_CONSUMER,
      data_version: DATA_VERSION,
      event_version: EVENT_VERSION,
      event: {
        ...eventDataHub,
        path: eventDataHub.path.replace(eventDataHub.queryParams, ''),
        user: {
          id: Number.parseInt(String(eventDataHub?.user?.id))
        }
      }
    }

    this.sendEvent(event)
  }

  static sendInjectionError(event: InjectionErrorEvent) {
    EventAgent.send({
      system: 'app_pixel',
      entity: 'injection',
      action: 'error',
      data_version: '1.0',
      event
    })
  }
}

export default DatahubEvent
